export default __webpack_public_path__ + "static/media/logo-amiltone.2b1b988e.png";